import { render, staticRenderFns } from "./OneIdProvider.vue?vue&type=template&id=886bf1ac&scoped=true&"
import script from "./OneIdProvider.vue?vue&type=script&lang=js&"
export * from "./OneIdProvider.vue?vue&type=script&lang=js&"
import style0 from "./OneIdProvider.vue?vue&type=style&index=0&id=886bf1ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886bf1ac",
  null
  
)

export default component.exports